export const tableDictionary = {
  labelText: '',
  emptyData: "Ma'lumot topilmadi",
}
